import { useTranslation } from 'react-i18next';

export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'de' ? 'en' : 'de';
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-3 py-1.5 text-sm font-semibold rounded-full border border-slate-200 hover:border-[#237CCA] hover:text-[#237CCA] transition-colors font-nunito"
      aria-label="Toggle Language"
    >
      <span className={i18n.language === 'de' ? 'font-bold text-[#237CCA]' : 'text-slate-400'}>DE</span>
      <span className="text-slate-300">|</span>
      <span className={i18n.language === 'en' ? 'font-bold text-[#237CCA]' : 'text-slate-400'}>EN</span>
    </button>
  );
}
